import { useState, Suspense, Fragment, lazy } from "react";
import { useSelector } from "react-redux";
import ChatbotLauncher from "app/components/chatbot/ChatbotLauncher";
import ChatbotPanel from "app/components/chatbot/ChatbotPanel";

import Customizer from "./shared/Customizer";
import SessionExpiryManager from "app/components/SessionExpiryManager";

const layouts = {
  layout1: lazy(() => import("./layout-1/Layout1")),
  layout2: lazy(() => import("./layout-2/Layout2"))
};

export default function GullLayout({ children }) {
  const { settings } = useSelector((state) => state.layout);
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  // SELECTED LAYOUT BASED ON ACTIVE SETTING
  const Layout = layouts[settings.activeLayout];

  return (
    <Suspense>
      <Fragment>
        <Layout>{children}</Layout>
        <SessionExpiryManager />
        <ChatbotPanel
          isOpen={isChatbotOpen}
          onClose={() => setIsChatbotOpen(false)}
        />
        <ChatbotLauncher
          isOpen={isChatbotOpen}
          onClick={() => setIsChatbotOpen((prev) => !prev)}
        />
        {/* {settings.customizer.show ? <Customizer /> : null} */}
      </Fragment>
    </Suspense>
  );
}
